import api from "../utils/api";

export const initQualification = (
  cpf,
  customer_id,
  consumer_units,
  origin,
  force_run,
  customer_numbers,
  utility_company,
  complementary_data,
  agent_email,
) =>
  api.post(process.env.VUE_APP_QUALIFICATIONINIT, {
    cpf,
    customer_id,
    consumer_units,
    origin,
    force_run,
    customer_numbers,
    utility_company,
    complementary_data,
    agent_email,
  });

export const initQualificationByForm = (
  cpf,
  customer_id,
  consumer_units,
  customer_numbers,
  origin,
  form_data,
  utility_company,
  complementary_data,
  agent_email,
  partner_origin,
  verify_qualification_rules,
) =>
  api.post(process.env.VUE_APP_QUALIFICATIONINITBYFORM, {
    cpf,
    customer_id,
    consumer_units,
    customer_numbers,
    origin,
    form_data,
    utility_company,
    complementary_data,
    agent_email,
    partner_origin,
    verify_qualification_rules,
  });

export const finishQualification = async (
  cpf,
  customer_id,
  qualification_ids,
  percentage_discount,
  unique_billing,
  power_plant,
  plan,
  seller,
  origin,
  agent_email,
) => {
  return await api.post(process.env.VUE_APP_QUALIFICATIONFINISH, {
    cpf,
    customer_id,
    qualification_ids,
    percentage_discount,
    unique_billing,
    power_plant,
    plan,
    seller,
    origin,
    agent_email,
  });
};

export const reprocessQualification = (id) =>
  api.post(process.env.VUE_APP_QUALIFICATIONREPROCESS, { id });

export const calcQualification = (
  percentage_discount,
  fare_amount,
  rate_class,
  history,
) =>
  api.post(process.env.VUE_APP_CREDIT_API, {
    percentage_discount,
    fare_amount,
    rate_class,
    history,
  });
